import { IStyleConfig, mergeStyles } from '@cian/components';
import * as React from 'react';

const styles = require('./promo_label.css');

interface IProps {
  labelStyle?: IStyleConfig;
}

export class PromoLabel extends React.PureComponent<IProps, object> {
  public render() {
    const labelStyles = mergeStyles(styles['promo-label'], this.props.labelStyle);

    return <div {...labelStyles}>{this.props.children}</div>;
  }
}
